module.exports = "/images/start-collect-customer-data.svg?b13ab20984974b22d644df2317d671f5";